export const production = 'production';
export const development = 'development';
const config = {
  enviroment: process.env.REACT_APP_ENV,
  apiUri: process.env.REACT_APP_API_ENV,
  apiKey: process.env.REACT_APP_API_KEY,
  apiVersion: process.env.REACT_APP_API_VERSION
}

export default config;
